import React from 'react'
import { GetStaticPaths, GetStaticProps } from 'next'
import { NextPageWithLayout } from '@/layouts'
import { PresalesLayout } from '@/layouts/PresalesLayout'
import { getShopifyCollection, ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { getLocaleFromParams } from '@/utils/LocaleUtil'
import { getStaticPropsErrorHandler, getUrlFromThisFilePath } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { PreSalesGiveawayView } from '@/views/PreSales/PreSalesGiveawayView'

interface PreSalesPageProps {
  theatricalSlug: string
  tickets: ShopifyProductWithBundles[]
}

export const PreSalesPage: NextPageWithLayout<PreSalesPageProps> = ({ tickets, theatricalSlug }) => {
  return (
    <div className="absolute inset-0 !top-0 !overflow-x-hidden bg-white lg:fixed">
      <PreSalesGiveawayView theatricalSlug={theatricalSlug} tickets={tickets} />
    </div>
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  return getStaticPropsErrorHandler({ requestUrl: getUrlFromThisFilePath(params) }, async () => {
    const locale = getLocaleFromParams(params)
    const theatricalSlug = params?.slug as string
    const tickets = await getShopifyCollection({ collectionId: 'gid://shopify/Collection/436194312423' })

    try {
      return {
        props: {
          tickets,
          theatricalSlug,
          ...(await loadTranslations(locale, ['common', 'home', 'tickets', 'chatbot', 'account'])),
        },
      }
    } catch (e) {
      return {
        notFound: true,
      }
    }
  })
}

PreSalesPage.getLayout = (page) => {
  return <PresalesLayout isDarkMode={false}>{page}</PresalesLayout>
}
export default PreSalesPage
